import React, {Fragment} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ResponseType} from "./ResponseType";
import {getMessage} from "../util";

const NotFound = (props:ResponseType) => {
    return(
        <Fragment>

            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>
                    <br/>
                    <p >
                        Según los registros incorporados para esta Consulta Ciudadana, obtenidos a partir del padrón electoral, <b>usted no figura dentro de una comuna de la Región de la Araucanía</b>. Si esta información no está correcta, y se encuentra actualmente inscrito(a) en el registro electoral de una comuna de la Región de la Araucanía, complete el siguiente formulario para actualizar sus datos.
                    </p>

                </Col>
            </Row>
            <Row className={"justify-content-center"}>

                <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>

                    <Button className="EvColorBlue text-white m-1 btn btn-primary" target="_blank" href="https://evoting.typeform.com/to/PT3nm2t2"
                            variant="primary">FORMULARIO</Button>
                    <br/>
                    <br/>
                    <Button className="EvColorGrisLight m-1" onClick={props.volver}
                            variant="light">{getMessage('ask_again', props.messages)}</Button>
                </Col>
            </Row>
        </Fragment>

    )
}

export default NotFound;